import { render, staticRenderFns } from "./VisitsView.vue?vue&type=template&id=2b3acade&"
import script from "./VisitsView.vue?vue&type=script&lang=js&"
export * from "./VisitsView.vue?vue&type=script&lang=js&"
import style0 from "./VisitsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VisitsView.vue"
export default component.exports